import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionTypes from "../Actions/actionTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as Common from "./common";
import * as StepsInfo from "./stepsInfo";
import * as ServicesData from "./servicesData";
import * as Providers from "./providers";
import * as Locations from "./locations";
import * as Availability from "./availability";
import { reducer as reduxFormReducer } from "redux-form";

export const rootReducer = (
    state: StoreTypes.IStore,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): StoreTypes.IStore => {
    return {
        initialSettings: state.initialSettings,
        common: Common.common(state.common, action, state.initialSettings),
        stepsInfo: StepsInfo.stepsInfo(
            state.stepsInfo,
            action,
            state.initialSettings,
            state.servicesData,
            state.locations,
            state.providers,
            state.common.clients
        ),
        servicesData: ServicesData.servicesData(state.servicesData, action),
        locations: Locations.locations(state.locations, action),
        providers: Providers.providers(state.providers, action),
        availability: Availability.availability(state.availability, action),
        submitForm: reduxFormReducer(state.submitForm, action),
    };
};
